// extracted by mini-css-extract-plugin
export var $animation_name = "GermanyHero-module--$animation_name--16ee3";
export var germanyHeroWrapper = "GermanyHero-module--germanyHeroWrapper--18b3c";
export var germanyHeroWrapper__desktop = "GermanyHero-module--germanyHeroWrapper__desktop--2e9e2";
export var germanyHeroWrapper__inner = "GermanyHero-module--germanyHeroWrapper__inner--05ef6";
export var germanyHeroWrapper__mobile = "GermanyHero-module--germanyHeroWrapper__mobile--27c3e";
export var topImage = "GermanyHero-module--topImage--d75ff";
export var topImage__content = "GermanyHero-module--topImage__content--39418";
export var topImage__link = "GermanyHero-module--topImage__link--7b390";
export var topImage__links = "GermanyHero-module--topImage__links--14c75";